import { Component, OnInit } from '@angular/core';
import { ToastrManager } from 'ng6-toastr-notifications';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { ExpenseService } from 'src/app/services/expense.service';
import { AuthService } from 'src/app/services/auth.service';
import { Tollbooth } from 'src/app/models/tollbooth';

@Component({
  selector: 'app-expense-tollbooth',
  templateUrl: './expense-tollbooth.component.html',
  styleUrls: ['./expense-tollbooth.component.css']
})
export class ExpenseTollboothComponent implements OnInit {

  by:string = '';
  tollbooths:Tollbooth[] = [];
  actGetExpTollBooth:boolean = true;
  expand:boolean = false;

  constructor(private expenseServ:ExpenseService,private auth:AuthService,private toast:ToastrManager) { }

  ngOnInit() {
    this.actGetExpTollBooth = this.auth.can("get-tollbooth");
  }

  async importTollBooth(event){
    let file = event.target.files[0];
    if(file){
      if(file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
        await this.expenseServ.updateTollboothByExcel(this.by,file);
        this.toast.infoToastr("Los datos fueron cargados correctamente");
        this.tollbooths = await this.expenseServ.getTollbooth();
      }else{
        this.toast.infoToastr("El archivo seleccionado no es de tipo Excel","Archivo Erroneo");
      }
    }
  }

}
